import { usePoisBountyContext } from "components/PoisBountyWidgetV3/context";
import { useAppSelector } from "hooks";
import { selectPoisBountyV3State } from "redux/slices";
import { Container } from "./styles";

const CyclesIndicator = () => {
	const { tracker } = useAppSelector(selectPoisBountyV3State);
	const { isPortrait } = usePoisBountyContext();

	return (
		<>
			{tracker?.cycleIndex !== undefined && (
				<Container
					className={`
                        ${isPortrait && "portrait"}
                    `}
				>
					<p>
						Cycle: {tracker.cycleIndex + 1}
						{tracker?.maxCycles && ` of ${tracker.maxCycles}`}
					</p>
				</Container>
			)}
		</>
	);
};

export default CyclesIndicator;
